import { styled } from '@linaria/react';
import { ReactNode } from 'react';
import { secondaryBase, skyLight } from '../../styles/design-tokens';
import { Icon } from '../../ui-library/icon/icon';

type TimelineTransitionProps = {
  children: ReactNode;
  isLast?: boolean;
  iconDirection?: 'up' | 'down';
  symbolColor?: string;
};

export const TimelineTransition = ({
  children,
  isLast = false,
  iconDirection = 'up',
  symbolColor = '#C4B5FD',
}: TimelineTransitionProps) => {
  const iconName = iconDirection === 'up' ? 'keyboard_arrow_up' : 'keyboard_arrow_down';

  return (
    <TimelineContainer style={{ marginBottom: isLast ? 0 : '16px' }}>
      <TimelineSymbolContainer>
        <TimelineSymbol $symbolColor={symbolColor}>
          <Icon name={iconName} size={16} color={secondaryBase} />
        </TimelineSymbol>
        {!isLast && <TimelineLine />}
      </TimelineSymbolContainer>
      <TransitionContent>{children}</TransitionContent>
    </TimelineContainer>
  );
};

const TimelineContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  overflow: visible;
`;

const TimelineSymbolContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-right: 12px;
  height: 100%;
`;

const TimelineSymbol = styled.div<{ $symbolColor: string }>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: ${(props) => props.$symbolColor};
  margin-bottom: 4px;
  z-index: 1;
`;

const TimelineLine = styled.div`
  width: 2px;
  height: 32px;
  background-color: ${skyLight};
`;

const TransitionContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding-bottom: 12px;
  flex: 1;
  min-width: 0;
  width: calc(100% - 36px);
  overflow: hidden;
`;
